import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { clearAuth } from "@/utils/auth";
// 延迟导入 router，避免 request → router → layout → request 循环依赖
function getRouter() {
  return import("@/router").then((m) => m.default);
}

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "",
  timeout: 15000,
});

function extractErrorMessage(error) {
  const res = error.response && error.response.data;
  if (res && typeof res.msg === "string" && res.msg) {
    return res.msg;
  }
  if (error.message) {
    return error.message;
  }
  return "网络错误";
}

function rejectWithCode(msg, code) {
  const err = new Error(msg || "请求失败");
  if (code != null) err.code = code;
  return Promise.reject(err);
}

function isAuthExpiredCode(code) {
  return code === 401 || code === 40101;
}

function handleUnauthorized(msg, config) {
  clearAuth();
  store.commit("RESET_STATE");
  if (config && config.skipAuthRedirect) {
    return;
  }
  Message.error(msg || "未登录或已过期");
  getRouter().then((router) => {
    if (router.currentRoute.path !== "/login") {
      router.replace("/login").catch(() => {});
    }
  });
}

service.interceptors.request.use(
  (config) => {
    const token = store.state.token;
    if (token) {
      config.headers.Authorization = "Bearer " + token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

service.interceptors.response.use(
  async (response) => {
    if (response.config && response.config.rawResponse) {
      const contentType = (response.headers && response.headers["content-type"]) || "";
      if (response.config.responseType === "blob" && contentType.indexOf("application/json") >= 0 && response.data instanceof Blob) {
        const text = await response.data.text();
        const res = JSON.parse(text || "{}");
        if (isAuthExpiredCode(res.code)) {
          handleUnauthorized(res.msg, response.config);
          return rejectWithCode(res.msg || "未登录", res.code);
        }
        if (res.code !== 0) {
          if (response.config.showError !== false) {
            Message.error(res.msg || "请求失败");
          }
          return rejectWithCode(res.msg || "请求失败", res.code);
        }
      }
      return response;
    }
    const res = response.data;
    if (isAuthExpiredCode(res.code)) {
      handleUnauthorized(res.msg, response.config);
      return rejectWithCode(res.msg || "未登录", res.code);
    }
    if (res.code !== 0) {
      const msg = res.msg || "请求失败";
      if (response.config.showError !== false) {
        Message.error(msg);
      }
      return rejectWithCode(msg, res.code);
    }
    return res.data;
  },
  (error) => {
    const res = error.response && error.response.data;
    const status = error.response && error.response.status;
    const msg = extractErrorMessage(error);
    const code = res && res.code;

    if (status === 401 || (res && isAuthExpiredCode(res.code))) {
      handleUnauthorized(msg, error.config);
      return rejectWithCode(msg, code != null ? code : 401);
    }

    if (error.config && error.config.showError !== false) {
      Message.error(msg);
    }
    return rejectWithCode(msg, code);
  }
);

export default service;
